import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { ASSETS_URLS } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, PUT, DELETE } = HTTP_METHODS;
const { ASSETS } = ASSETS_URLS;

export const assetsApi = createApi({
  reducerPath: 'assetsApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getAssets: builder.query({
      query: (data) => ({ url: `${ASSETS}${buildQueryString(data)}`, method: GET })
    }),
    addAssets: builder.mutation({
      query: (data) => ({ url: ASSETS, method: POST, data })
    }),
    deleteAssets: builder.mutation({
      query: (id) => ({
        url: `${ASSETS}/${id}`,
        method: DELETE
      })
    }),
    editAssets: builder.mutation({
      query: (data) => ({
        url: `${ASSETS}/${data?.id}`,
        method: PUT,
        data: data?.data
      })
    }),
    getAllAssets: builder.query({
      query: (data) => ({ url: `${ASSETS}${buildQueryString(data)}`, method: GET })
    })
  })
});

export const {
  useAddAssetsMutation,
  useDeleteAssetsMutation,
  useEditAssetsMutation,
  useGetAllAssetsQuery,
  useGetAssetsQuery
} = assetsApi;
